import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext({ lang: "es", setLang: () => {}, t: () => "" });

const dict = {
  nav: {
    services: { es: "Servicios", en: "Services" },
    readings: { es: "Lecturas", en: "Readings" },
    witchcraft: { es: "Hechicería", en: "Witchcraft" },
    chat: { es: "Consulta", en: "Consult" },
    predictions: { es: "Predicciones", en: "Predictions" },
    testimonials: { es: "Testimonios", en: "Testimonials" },
    test: { es: "Pago Prueba", en: "Test Payment" },
    payment: { es: "Pago", en: "Payment" },
    contact: { es: "Contacto", en: "Contact" },
  },
  hero: {
    eyebrow: { es: "Servicios Espirituales", en: "Spiritual Services" },
    title: { es: "Lecturas y Trabajos\nde Hechicería", en: "Readings and\nWitchcraft Works" },
    subtitle: {
      es: "Sabiduría ancestral. Resultados reales. Atendido personalmente por CrisAngel Astral.",
      en: "Ancestral wisdom. Real results. Personally attended by CrisAngel Astral.",
    },
    ctaPrimary: { es: "Ver Servicios", en: "View Services" },
    ctaSecondary: { es: "Hablar por WhatsApp", en: "Chat on WhatsApp" },
    testCta: {
      es: "¿Dudas? Verifica que el pago llega — Cargo real reembolsable",
      en: "Unsure? Verify the payment works — Real refundable charge",
    },
  },
  sections: {
    readingsTitle: { es: "Lecturas Disponibles", en: "Available Readings" },
    readingsSubtitle: {
      es: "Consulta el oráculo. Recibe respuestas claras.",
      en: "Consult the oracle. Receive clear answers.",
    },
    witchcraftTitle: { es: "Servicios de Hechicería", en: "Witchcraft Services" },
    witchcraftSubtitle: {
      es: "Trabajos espirituales personalizados para cada propósito.",
      en: "Custom spiritual works for every purpose.",
    },
    paymentTitle: { es: "Cómo Realizar tu Pago", en: "How to Make Your Payment" },
    bonusTitle: { es: "Bono Cliente Nuevo", en: "New Client Bonus" },
    bonusText: {
      es: "Todos los trabajos de hechicería incluyen una Lectura Completa sin costo adicional.",
      en: "All witchcraft works include a complimentary Complete Reading at no extra cost.",
    },
  },
  card: {
    viewDetails: { es: "Ver Detalles y Pagar", en: "View Details & Pay" },
    duration: { es: "Duración", en: "Duration" },
    includes: { es: "Incluye", en: "Includes" },
    from: { es: "Desde", en: "From" },
  },
  dialog: {
    payOnline: { es: "Pagar en Línea", en: "Pay Online" },
    bankTransfer: { es: "Transferencia Bancaria", en: "Bank Transfer" },
    payPaypal: { es: "Pagar con PayPal", en: "Pay with PayPal" },
    contactWhatsapp: { es: "Contactar por WhatsApp", en: "Contact via WhatsApp" },
    selectCurrency: { es: "Selecciona moneda", en: "Select currency" },
    closeBtn: { es: "Cerrar", en: "Close" },
    bankData: { es: "Datos Bancarios", en: "Bank Details" },
    bank: { es: "Banco", en: "Bank" },
    clabe: { es: "CLABE Interbancaria", en: "CLABE" },
    card: { es: "Tarjeta de Débito", en: "Debit Card" },
    beneficiary: { es: "Beneficiario", en: "Beneficiary" },
    afterPayment: {
      es: "Tras realizar tu pago bancario, envía tu comprobante por WhatsApp para confirmar y agendar.",
      en: "After your bank payment, send your receipt via WhatsApp to confirm and schedule.",
    },
    copy: { es: "Copiar", en: "Copy" },
    copied: { es: "Copiado", en: "Copied" },
    processing: { es: "Procesando...", en: "Processing..." },
    paypalNote: {
      es: "Próximamente. Por ahora, contáctanos por WhatsApp para pagos con PayPal.",
      en: "Coming soon. For now, contact us via WhatsApp for PayPal payments.",
    },
  },
  success: {
    title: { es: "¡Pago Exitoso!", en: "Payment Successful!" },
    subtitle: {
      es: "Gracias. Agenda ahora tu sesión seleccionando fecha y hora.",
      en: "Thank you. Now schedule your session by selecting a date and time.",
    },
    verifying: { es: "Verificando tu pago...", en: "Verifying your payment..." },
    fullName: { es: "Nombre completo", en: "Full name" },
    email: { es: "Correo electrónico", en: "Email" },
    phone: { es: "Teléfono / WhatsApp", en: "Phone / WhatsApp" },
    date: { es: "Fecha preferida", en: "Preferred date" },
    time: { es: "Hora preferida", en: "Preferred time" },
    notes: { es: "Notas adicionales (opcional)", en: "Additional notes (optional)" },
    submit: { es: "Confirmar Agenda", en: "Confirm Booking" },
    booked: { es: "¡Sesión Agendada!", en: "Session Booked!" },
    bookedMsg: {
      es: "Recibirás un mensaje por WhatsApp para confirmar tu horario.",
      en: "You will receive a WhatsApp message confirming your time slot.",
    },
    backHome: { es: "Volver al inicio", en: "Back home" },
  },
  cancel: {
    title: { es: "Pago Cancelado", en: "Payment Cancelled" },
    msg: {
      es: "No se realizó ningún cargo. Puedes intentarlo de nuevo cuando gustes.",
      en: "No charge was made. You can try again whenever you want.",
    },
    backHome: { es: "Volver al inicio", en: "Back home" },
  },
  payment: {
    step1: { es: "Realiza tu depósito o transferencia.", en: "Make your deposit or transfer." },
    step2: { es: "Envía tu comprobante por WhatsApp.", en: "Send your receipt via WhatsApp." },
    step3: { es: "Confirma el servicio que deseas contratar.", en: "Confirm the service you want." },
    step4: {
      es: "Una vez validado el pago, recibirás los horarios disponibles o el seguimiento de tu trabajo espiritual.",
      en: "Once payment is validated, you'll receive available times or follow-up on your spiritual work.",
    },
    orPay: { es: "Métodos de pago aceptados", en: "Accepted payment methods" },
    onlineDescription: {
      es: "Aceptamos transferencia bancaria, PayPal, remesas internacionales (Wise, Remitly, Western Union) y retiro en efectivo en Soriana.",
      en: "We accept bank transfer, PayPal, international remittance (Wise, Remitly, Western Union) and cash pickup at Soriana.",
    },
  },
  footer: {
    rights: { es: "Todos los derechos reservados.", en: "All rights reserved." },
    disclaimer: {
      es: "Servicios espirituales con fines orientativos. Mayores de 18 años.",
      en: "Spiritual services for guidance purposes. 18+ only.",
    },
  },
  vidente: {
    title: { es: "Vidente Virtual", en: "Virtual Seer" },
    subtitle: {
      es: "Conversa por voz en vivo con Cristopher. Habla y él te responde con su voz.",
      en: "Talk to Cristopher live by voice. Speak and he replies with his voice.",
    },
    startSession: { es: "Iniciar Sesión por Voz", en: "Start Voice Session" },
    endSession: { es: "Cerrar", en: "End" },
    holdToTalk: { es: "Mantén el micrófono para hablar", en: "Hold the mic to talk" },
    releaseToSend: { es: "Suelta para enviar", en: "Release to send" },
    drawReadyHint: {
      es: "Cristopher decidirá cuándo encender el mazo",
      en: "Cristopher will decide when the deck is ready",
    },
    drawReadyNow: {
      es: "El mazo dorado ya está listo, tócalo cuando quieras",
      en: "The golden deck is ready, tap it when you want",
    },
    drawReadyBadge: { es: "🎴 LISTO", en: "🎴 READY" },
    correctData: { es: "Corregir datos", en: "Correct data" },
    showMessages: { es: "Mostrar mensajes", en: "Show messages" },
    hideMessages: { es: "Ocultar mensajes", en: "Hide messages" },
    audioOn: { es: "Audio activado", en: "Audio on" },
    audioOff: { es: "Audio silenciado", en: "Audio muted" },
    rating: {
      title: { es: "¿Cómo estuvo tu sesión con Cristopher?", en: "How was your session with Cristopher?" },
      subtitle: {
        es: "Tu opinión nos ayuda a mejorar. Puedes cambiar tu calificación más tarde.",
        en: "Your feedback helps us improve. You can change your rating later.",
      },
      placeholder: {
        es: "Cuéntale a Cristopher qué te pareció (opcional)…",
        en: "Tell Cristopher what you thought (optional)…",
      },
      submit: { es: "Enviar calificación", en: "Send rating" },
    },
  },
  sorteo: {
    liveLabel: { es: "En vivo", en: "Live" },
    voteThePower: { es: "Vota el poder del giro", en: "Vote the spin power" },
    spinNow: { es: "Girar ahora", en: "Spin now" },
    winner: { es: "Ganador", en: "Winner" },
    powers: {
      slow: { es: "Suave", en: "Soft" },
      normal: { es: "Normal", en: "Normal" },
      strong: { es: "Fuerte", en: "Strong" },
    },
    broadcastUnavailable: {
      es: "El admin todavía no encendió la transmisión.",
      en: "The admin hasn't started the broadcast yet.",
    },
    broadcastConnecting: { es: "Conectando con la transmisión…", en: "Connecting to broadcast…" },
  },
  memory: {
    spiritualProfileTitle: { es: "Tu Perfil Espiritual", en: "Your Spiritual Profile" },
    spiritualProfileSubtitle: {
      es: "Lo que Cristopher ha percibido sobre ti a lo largo de tus sesiones.",
      en: "What Cristopher has perceived about you across your sessions.",
    },
    notYetBuilt: {
      es: "Aún no has tenido suficientes sesiones para que Cristopher construya tu perfil.",
      en: "You haven't had enough sessions for Cristopher to build your profile yet.",
    },
  },
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("lang") || "es");

  useEffect(() => {
    localStorage.setItem("lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = (path) => {
    const parts = path.split(".");
    let cur = dict;
    for (const p of parts) {
      if (!cur || cur[p] === undefined) return path;
      cur = cur[p];
    }
    if (typeof cur === "object" && cur[lang] !== undefined) return cur[lang];
    return path;
  };

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
